import Profile from "views/examples/Profile";
import CashierDashboard from "views/cashier/CashierDashboard";
import POS from "views/cashier/Pos";
// import RegisterSession from "views/cashier/RegisterSession";
// import CashWithdrawals from "views/cashier/CashWithdrawals";
// import SalesHistory from "views/cashier/SalesHistory";

var cashierRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <CashierDashboard />,
    layout: "/cashier",
    sidebar: true,
  },
  {
    path: "/pos",
    name: "Pos",
    icon: "ni ni-credit-card text-primary",
    component: <POS />,
    layout: "/cashier",
    sidebar: true,
    fullPage: true,
  },
  // {
  //   path: "/register",
  //   name: "Register Session",
  //   icon: "ni ni-money-coins text-success",
  //   component: <RegisterSession />,
  //   layout: "/cashier",
  //   sidebar: true,
  // },
  // {
  //   path: "/withdrawals",
  //   name: "Cash Withdrawals",
  //   icon: "ni ni-cart text-warning",
  //   component: <CashWithdrawals />,
  //   layout: "/cashier",
  //   sidebar: true,
  // },
  // {
  //   path: "/sales",
  //   name: "Sales History",
  //   icon: "ni ni-bullet-list-67 text-info",
  //   component: <SalesHistory />,
  //   layout: "/cashier",
  //   sidebar: true,
  // },
  // {
  //   path: "/profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: <Profile />,
  //   layout: "/cashier",
  //   sidebar: false,
  // },
];

export default cashierRoutes;